export const getApiBase = (version = 'v2') => {
  if (process.env.REACT_APP_API_BASE) return process.env.REACT_APP_API_BASE + version;
  return `https://child_journals-api${process.env.REACT_APP_BUILD_TARGET === 'production' ? '' : '-staging'
    }.lifetales.com/api/${version}`;
};
const apiBase = getApiBase();
export const baseUrl = apiBase.replace('/v2', '');

export default apiBase;
